import axios from "@/libs/api.request";
// 获取列表
export const getList = (data) => {
  return axios.request({
    url: "/shipments/ffc_shipment/FFCReturnList",
    data,
    method: "post",
  });
};
